export default __webpack_public_path__ + "static/media/car.39daadcc.svg";